<template>
  <b-container fluid>
    <b-row class="pt-3">
      <b-col>
        <b-form>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Name (ไม่จำเป็น)"
            label-for="customName"
          >
            <b-form-input
              v-model="customNameInput"
              type="text"
              @change="assignValue"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="รูปแบบ Ref Range"
            label-for="refRangeTypeLabel"
          >
            <b-form-select
              v-model="refRangeType"
              text-field="title"
              value-field="value"
              :options="refRangeTypeList"
              @change="assignValue"
            />
          </b-form-group>
          <b-form-group
            v-if="refRangeType == 'all'"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Ref Range"
            label-for="minLabel"
          >
            <b-form-textarea
              id="refRangeText"
              v-model="refRangeText"
              placeholder="<1.0ug/dL  : Low ......>"
              rows="3"
              max-rows="6"
              @change="assignValue"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            v-if="refRangeType == 'legacy'"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Min"
            label-for="minLabel"
          >
            <b-form-input
              v-model="minInput"
              type="text"
              @change="assignValue"
            />
          </b-form-group>
          <b-form-group
            v-if="refRangeType == 'legacy'"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Max"
            label-for="maxLabel"
          >
            <b-form-input
              v-model="maxInput"
              type="text"
              @change="assignValue"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Specie"
            label-for="speciesChooseLabel"
          >
            <b-row class="pb-3">
              <template v-slot:first>
                <b-col cols="auto" class="col-left">
                  <b-form-checkbox
                    v-model="checkAllSpecies"
                    :indeterminate.sync="indeterminateSpecie"
                    @change="checkAllSpeciesHandler"
                    >เลือกทั้งหมด</b-form-checkbox
                  >
                </b-col>
              </template>
            </b-row>
            <b-form-checkbox-group
              id="speciesChooseInput"
              v-model="specieChoose"
              name="speciesChooseInput"
            >
              <b-row>
                <template v-for="(specie, index) in species">
                  <b-col :key="index" cols="2" class="col-left">
                    <b-form-checkbox :value="specie.id">{{
                      specie.species_name
                    }}</b-form-checkbox>
                  </b-col>
                </template>
              </b-row>
            </b-form-checkbox-group>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RefRangeMultiCreate",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    testId: {
      type: Number,
      default: () => null,
    },
    type: {
      type: String,
      default: null,
    },
    testLevel: {
      type: String,
      default: "test",
    },
  },
  data() {
    return {
      refRangeText: null,
      minInput: 0,
      maxInput: 0,
      customNameInput: null,
      specieChoose: [],
      indeterminateSpecie: false,
      checkAllSpecies: false,
      refRangeType: "all",
      refRangeTypeList: [
        {
          title: "แบบเก่า",
          value: "legacy",
        },
        {
          title: "แบบใหม่",
          value: "all",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      species: "Species/getAll",
    }),
  },
  watch: {
    specieChoose(value) {
      if (value.length === 0) {
        this.indeterminateSpecie = false;
        this.checkAllSpecies = false;
      } else if (value.length === this.species.length) {
        this.indeterminateSpecie = false;
        this.checkAllSpecies = true;
      } else {
        this.indeterminateSpecie = true;
        this.checkAllSpecies = false;
      }
      this.assignValue();
    },
    // minInput(value) {
    //   this.assignValue()
    // },
    // maxInput(value) {
    //   this.assignValue()
    // }
  },
  methods: {
    checkAllSpeciesHandler(checked) {
      this.specieChoose = checked
        ? this.species.map((specie) => specie.id)
        : [];
      this.assignValue();
    },
    assignValue() {
      const valueTemplate = {
        for_specie_id: null,
        custom_name: this.customNameInput,
        is_custom: false,
        id: this.testId,
        max: this.maxInput,
        min: this.minInput,
        type: this.testLevel,
        ref_range_type: this.refRangeType,
        ref_range_text: this.refRangeText,
      };

      if (this.customNameInput) {
        valueTemplate.is_custom = true;
      } else {
        valueTemplate.is_custom = false;
      }

      const value = this.specieChoose.map((specieId) => ({
        ...valueTemplate,
        for_specie_id: specieId,
      }));

      this.$emit("input", value);
    },
  },
};
</script>

<style scoped></style>
